module.exports = __webpack_public_path__ + "static/media/dtj-mockup-3.c0125a91.jpg";